import { ToggleActivityLogAdditionalData } from "./activitiesAdditionalData";

export const TOGGLE_ACTIVITY_LOG = 'TOGGLE_ACTIVITY_LOG'

export const toggleActivityLog = (docId: string, show: boolean): ToggleActivityLogAdditionalData => ({
    type: TOGGLE_ACTIVITY_LOG,
    show,
    docId
})
